import { render, staticRenderFns } from "./RootTemplate.vue?vue&type=template&id=5817444f&scoped=true"
import script from "./RootTemplate.vue?vue&type=script&lang=js"
export * from "./RootTemplate.vue?vue&type=script&lang=js"
import style0 from "./RootTemplate.vue?vue&type=style&index=0&id=5817444f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5817444f",
  null
  
)

export default component.exports